import React from 'react';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import StorageObjectListItem from './StorageObjectListItem';
import './BatchObjectList.scss';

const stripIdsIfDiscarded = (batch, objs) => {
  if (batch.discarded) {
    return objs.map(obj => Object.assign({}, obj, { id: undefined, storeId: undefined, container: undefined }));
  }
  return objs;
};

const BatchObjectList = ({ data: batch, configuration, canDelete, onDelete, repositoryService }) => {
  const { input, canDelete: configCanDelete, canDownload: configCanDownload } = configuration || {};
  let objects = input && batch.input;
  let canDownload = !batch.discarded;
  if (input) {
    objects = batch.input || [];
  } else if (batch.jobs && batch.jobs.length && batch.jobs[batch.jobs.length - 1].output) {
    objects = batch.jobs[batch.jobs.length - 1].output;
  } else if (batch.resultFiles && batch.resultFiles.length) {
    canDownload = false;
    objects = batch.resultFiles.map(r => ({ name: r }));
  } else {
    objects = [];
  }
  objects = stripIdsIfDiscarded(batch, objects);
  return (
    <div className="grb-batchobject-list">
      {objects.map(item => (
        <List key={item.storeId || item.id || item.name}>
          <StorageObjectListItem
            object={item}
            canDownload={canDownload === undefined ? configCanDownload : canDownload}
            canDelete={canDelete === undefined ? configCanDelete : canDelete}
            onDelete={onDelete}
            repositoryService={repositoryService}
            canSelect={false}
          />
        </List>
      ))}
    </div>
  );
};

BatchObjectList.propTypes = {
  data: PropTypes.shape({}).isRequired,
  configuration: PropTypes.shape({}),
  canDelete: PropTypes.bool,
  onDelete: PropTypes.func,
  repositoryService: PropTypes.shape({}).isRequired,
};

BatchObjectList.defaultProps = {
  configuration: {},
  canDelete: undefined,
  onDelete: undefined,
};

export default BatchObjectList;
